import axios from '../../../../utils/api'

const actions = {
  async findByCpfOrCnpj ({ commit }, cpfCnpj) {
    const result = await axios({
      url: 'portal/pessoa/findByCpfOrCnpj',
      params: {
        cpfCnpj
      },
      method: 'GET'
    })

    return result
  },
  async findAllCredenciadoVistoria ({ commit }) {
    const result = await axios({
      method: 'GET',
      url: `portal/pessoa/findAllCredenciadoVistoria`,
      error: true
    })

    return result
  },

  async findAllCredenciadoGeo ({ commit }) {
    const result = await axios({
      method: 'GET',
      url: `portal/pessoa/findAllCredenciadoGeo`,
      error: true
    })

    return result
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/seguranca/pessoa.js